export const HISTORY_MODULE_NAME = "history_module";

export const historyModuleMenuItem = {
  icon: "history",
  path: "/history",
};

export const historyModuleRoutes = [
  {
    path: "history",
    name: "SystemHistory",
    components: {
      default: () => import("./pages/SystemHistory.vue"),
    },
    meta: {
      title: "History",
      requiresAuth: true,
      requiresModule: HISTORY_MODULE_NAME,
    },
  },
];

export default {
  moduleName: HISTORY_MODULE_NAME,
  routes: historyModuleRoutes,
  menuItem: historyModuleMenuItem,
};
